

const DashGroups = () => {
  return (
    <div>
      <h1>Dash grupos</h1>

     
    </div>
  );
};

export default DashGroups;
